export const SET_SELECTED_ITEMS = "update-selected-items";
export const CHANGE_ACTIVE_PAGE = "change-active-page";
export const SET_ITEMS_PER_PAGE = "set-items-per-page";
export const SET_BULK_ACTIONS = "set-bulk-actions";
export const SET_DATA = "set-data";